module.exports = __webpack_public_path__ + "static/media/Plateforme-achat-tutoriel.19b4c632.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/tutorials/assets/pdfs/follo/fr/Plateforme-achat-tutoriel.pdf
// module id = ./src/statsradio/modules/tutorials/assets/pdfs/follo/fr/Plateforme-achat-tutoriel.pdf
// module chunks = 18